import {noop} from '@github-ui/noop'
import type {Dispatch, PropsWithChildren, SetStateAction} from 'react'
import {createContext, use, useMemo, useState} from 'react'

type NestedListItemActionsContextProps = {
  actionsOpen: boolean
  setActionsOpen: Dispatch<SetStateAction<boolean>>
}

const NestedListItemActionsContext = createContext<NestedListItemActionsContextProps>({
  actionsOpen: false,
  setActionsOpen: noop,
})

export const NestedListItemActionsProvider = ({children}: PropsWithChildren) => {
  const [actionsOpen, setActionsOpen] = useState(false)
  const contextProps = useMemo(() => ({actionsOpen, setActionsOpen}), [actionsOpen])
  return <NestedListItemActionsContext value={contextProps}>{children}</NestedListItemActionsContext>
}

export const useNestedListItemActions = () => {
  return use(NestedListItemActionsContext)
}

try{ NestedListItemActionsContext.displayName ||= 'NestedListItemActionsContext' } catch {}
try{ NestedListItemActionsProvider.displayName ||= 'NestedListItemActionsProvider' } catch {}